$(document).ready(function() {


    /* ------ Cookie ----- */

    $('#twc-cookie .cookie-btns__accept').click(function(e) {
        Cookies.set('cookies', 'true', { expires: 30 });
        $('#twc-cookie').hide();

        e.preventDefault();
    });

    $('#twc-cookie .cookie-close').click(function(e) {
        Cookies.set('cookies', 'true', { expires: 1 });
        $('#twc-cookie').hide();

        e.preventDefault();
    });

    if (Cookies.get('cookies') !== 'true') {
        $('#twc-cookie').show();
    }

    /* ------ Swatches ----- */

    var selectCallback = function(variant, selector) {
        // BEGIN SWATCHES
        if (variant) {
            var form = $('#' + selector.domIdPrefix).closest('form');
            for (var i = 0, length = variant.options.length; i < length; i++) {
                var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
                if (radioButton.size()) {
                    radioButton.get(0).checked = true;
                }
            }
        }
    };

    $('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
    });

    $('.swatch label').click(function() {
        $('.swatch label').removeClass('checked');
        $(this).addClass('checked');
    });

    /* ------ HOME ----- */

    $('.hero-slideshow').slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
        nextArrow: '<i class="fas fa-chevron-right slick-next"></i>'
    });

    /* ------ MEGA MENU ----- */

    $('.site-header .main-left li:nth-child(2) a').addClass('toggle-mega').attr('data-name', 'face').attr('href', '#');
    $('.site-header .main-left li:nth-child(3) a').addClass('toggle-mega').attr('data-name', 'eyes').attr('href', '#');
    $('.site-header .main-left li:nth-child(4) a').addClass('toggle-mega').attr('data-name', 'lips').attr('href', '#');

    //open the mega menu on click
    $('a.toggle-mega').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var whichMenu = $(this).attr('data-name');
        $('.mega-menu .single-mega .single-item').removeAttr('tabindex');
        $('.mega-menu .single-mega .single-item a').removeAttr('tabindex');
        //if it is the current opened item
        if ($(this).hasClass('open')) {
          $(this).removeClass('open');
          $('.mega-menu').removeClass('open');
          $('.mega-menu .single-mega[data-name="' + whichMenu + '"]').removeClass('open');
        } else {
          //if it is another menu item
          $('a.toggle-mega').removeClass('open');
          $('.mega-menu').removeClass('open');
          $('.mega-menu .single-mega').removeClass('open');
          $(this).toggleClass('open');
          $('.mega-menu').toggleClass('open');
          $('.mega-menu .single-mega[data-name="' + whichMenu + '"]').toggleClass('open');
          $('.mega-menu .single-mega[data-name="' + whichMenu + '"] a:first').focus();
        }
    });

    //at end of products menu, go to brand story
  	$('.mega-menu .single-mega a.button').on('keydown', function(e) {
      	var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '9') {
          e.preventDefault();
          if ($('a.toggle-mega').hasClass('open')) {
            $('a.toggle-mega.open').focus();
            $('a.toggle-mega').removeClass('open');
            $('.mega-menu').removeClass('open');
            $('.mega-menu .single-mega').removeClass('open');
          }
        }
    });

    //if escape is hit on any mega menu dropdown item
    $('.mega-menu .single-mega a').on('keydown', function(e) {
      var keycode = (e.keyCode ? e.keyCode : e.which);
      var whichMenu = $(this).closest('.mega-menu .single-mega').attr('data-name');
        if (keycode == '27') {
          $('a.toggle-mega[data-name="' + whichMenu + '"]').focus();
        };
    });

    // if the target of the click isn't a menu item or child
    $(document).on('click', function(e) {
        var container = $('.site-header .main-left ul.parent');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.mega-menu').removeClass('open');
            $('.toggle-mega').removeClass('open');
        }
    });

  //$('.mega-menu .single-mega[data-name="' + whichMenu + '"] a:first').focus();

    //$('.site-header .main-header a').hover(function() {

        //if ($(this).hasClass('open')) {

        //} else {
            //$('.mega-menu').removeClass('open');
            //$('.toggle-mega').removeClass('open');
        //}

    //});

    /* ------ Tabs ----- */

    $('.product-tabs .tab-name').click(function() {
        $(this).parent().siblings().find('.tab-content').hide();
        $(this).parent().siblings().find('.tab-name').removeClass('active');
        $(this).toggleClass('active');
        $(this).next('.tab-content').slideToggle();
    });

    /* ------ Mobile Menu ----- */

    $('.hamburger').on('click', function() {
        $(this).toggleClass('open');
        $('.mobile-menu').fadeToggle();
    });

    /* ------ Cart ----- */

    $('.cart__edit .cart__edit-text--edit').click(function() {
        $(this).hide();
        $(this).next().show();
        $(this).parent().parent().parent().parent().next('.cart__update-wrapper').addClass('active');
    });

    $('.cart__edit .cart__edit-text--cancel').click(function() {
        $(this).hide();
        $(this).prev().show();
        $(this).parent().parent().parent().parent().next('.cart__update-wrapper').removeClass('active');
    });

    /* ------ Modal ----- */

    $('#sizeguide').click(function(e) {
        $('.modal-sizeguide').fadeIn();
        e.preventDefault();
    });

    $('#RecoverPassword').click(function(e) {
        $('#password').fadeIn();
        e.preventDefault();
    });

    if (window.location.hash) {

        $('#password').fadeIn();

    }

    $('.modal .close').click(function(e) {
        $('.modal').fadeOut();
        e.preventDefault();
    });

    /* ------ Modal > Newsletter ----- */

    if (Cookies.get('email') !== 'true') {
        function explode() {
            $('#email').fadeIn();
        }
        setTimeout(explode, 5000);
    }

    $('#email .close').click(function(e) {
        Cookies.set('email', 'true', { expires: 30 });
        e.preventDefault();
    });

    /* ------ Product Slider ----- */

    $('.product-slider').slick({
        dots: false,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 7000,
        slidesToShow: 5,
        slidesToScroll: 1,
        appendArrows: '.product-arrows',
        responsive: [{
                breakpoint: 768,
                settings: {
                    dots: false,
                    arrows: true,
                    autoplay: false,
                    autoplaySpeed: 7000,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    appendArrows: '.product-arrows',
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    arrows: false,
                    autoplay: false,
                    autoplaySpeed: 7000,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.product-slider.menu-slider').slick('unslick');


    /* ------ Testimonial Slider ----- */

    $('.testimonials-slider').slick({
        dots: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 7000,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '370px',
        responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ]
    });


    /* ------ FAQs > Nav ----- */

    $('.faq-nav a[href^="#"]').on('click', function(e) {
        e.preventDefault();

        var target = this.hash;
        var $target = $(target);

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - 90
        }, 900, 'swing', function() {
            window.location.hash = target;
        });
    });


    /* ------ FAQs > Questions ----- */

    $('.faq-items .question').click(function() {
        $('.faq-items .answer').slideUp();
        $('.faq-items .question').removeClass('active');
        $(this).addClass('active');
        $(this).next('.answer').slideDown();
    });

    /* ------ Header > Has Children ----- */

    $('.site-header .child').prev().addClass('has-children');

    /* ------ Header > Search ----- */

    $('.toggle-search a').click(function(e) {
        $('.search-box').toggleClass('open');
        e.preventDefault();
    });
  $('.toggle-search a').on('keypress', function(e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '13') {
            $('.search-box').addClass('open');
            $('.search-box .search #q').focus();
            e.preventDefault();
        }
    });

    $(document).on('click', function(e) {
        var container = $(".toggle-search");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.search-box').removeClass('open');
        }
    });

    /* ------ ADA ------ */
    //removing classes on escape
    $(document).on('keyup', function(e) {
          var keycode = (e.keyCode ? e.keyCode : e.which);
          if (keycode == '27') {
              $('.search-box').removeClass('open');
              $('a.toggle-mega').removeClass('open');
              $('.mega-menu').removeClass('open');
              $('.mega-menu .single-mega').removeClass('open');
          }
    });

    /* ------ Home > Instagram ----- */

    var feed = new Instafeed({
        get: 'user',
        userId: '5864473935',
        resolution: 'standard_resolution',
        limit: 6,
        clientId: '3ac7e58b817c429b9d160b4fa541f0ac',
        accessToken: '5864473935.1677ed0.7f8861f03f234834a1672def0cf9c06b'
    });
    feed.run();
});